interface bptlRes {
  [key: string]: string[]
}

const BPTL_RESULTS: bptlRes = {
  Bedfordshire: [
    'Biggleswade',
    'Ampthill',
    'Bedford',
    'Leighton Buzzard',
    'Turvey',
    'Woburn',
    'Barton-Le-Clay',
    'Shefford',
    'Studham',
    'Potton'
  ],
  Berkshire: [
    'Caversham',
    'Mortimer',
    'Finchampstead',
    'Pangbourne',
    'Windsor',
    'Yattendon',
    'Hungerford',
    'Sonning',
    'Bray',
    'Hurley'
  ],
  Buckinghamshire: [
    'Marlow',
    'Amersham',
    'Beaconsfield',
    'Great Missenden',
    'Olney',
    'Brill',
    'West Wycombe',
    'Chesham',
    'Turville',
    'Gerrards Cross'
  ],
  Cambridgeshire: [
    'St Ives',
    'Elton',
    'Ely',
    'Godmanchester',
    'Newnham, Cambridge',
    'Linton',
    'The Shelfords',
    'Bourn',
    'Whittlesford',
    'Buckden'
  ],
  Cornwall: [
    'Bude',
    'Hayle',
    'Truro',
    'Wadebridge',
    'Penzance',
    'Cawsand and Kingsand',
    'Flushing, Falmouth',
    'Newquay',
    'St Agnes',
    'Porthleven'
  ],
  Derbyshire: [
    'Ashbourne',
    'Bakewell',
    'Belper',
    'Buxton',
    'Melbourne',
    'Wirksworth',
    'Repton',
    'Darley Abbey',
    'Hathersage',
    'Tideswell'
  ],
  Devon: [
    'Appledore',
    'Exeter',
    'Topsham',
    'Kingsbridge',
    'Totnes',
    'Ashburton',
    'Budleigh Salterton',
    'Tavistock',
    'Bampton',
    'Okehampton'
  ],
  Dorset: [
    'Wimborne',
    'Sherborne',
    'Lyme Regis',
    'Swanage',
    'Bridport',
    'Beaminster',
    'Mudeford',
    'Poundbury',
    'Westbourne',
    'Studland'
  ],
  Essex: [
    'Saffron Walden',
    'Chelmsford',
    'Leigh-on-Sea',
    'Stock',
    'Colchester',
    'Frinton-on-Sea',
    'Thaxted',
    'Wivenhoe',
    'Brentwood',
    'Great Dunmow'
  ],
  Gloucestershire: [
    'Cirencester',
    'Bourton-on-the-Water',
    'Tetbury',
    'Winchcombe',
    'Chipping Campden',
    'Nailsworth',
    'Coleford',
    'Painswick',
    'Charlton Kings',
    'Wotton-under-Edge'
  ],
  'Hampshire & IOW': [
    'Lymington',
    'Winchester',
    'Petersfield',
    'Southsea',
    'Cowes',
    'Stockbridge',
    'Alton',
    'Bishop’s Waltham',
    'Alresford',
    'Overton'
  ],
  Hertfordshire: [
    'St Albans',
    'Tring',
    'Hitchin',
    'Hertford',
    'Welwyn Garden City',
    'Rickmansworth',
    `Bishop’s Stortford`,
    'Letchworth',
    'Buntingford',
    'Royston'
  ],
  Kent: [
    'Tunbridge Wells',
    'Sevenoaks',
    'Faversham',
    'Tenterden',
    'Cranbrook',
    'Tankerton',
    'Speldhurst',
    'Folkestone',
    'Ickham',
    'Westerham'
  ],
  'Leicestershire & Rutland': [
    'Market Harborough',
    'Uppingham',
    'Mountsorrel',
    'Melton Mowbray',
    'Leicester',
    'Ashby-de-la-Zouch',
    'Market Bosworth',
    'Oakham',
    'Kirby Muxloe',
    'Clarendon Park'
  ],
  Norfolk: [
    `Holt`,
    `Norwich`,
    `King’s Lynn`,
    `Great Massingham`,
    `Aylsham`,
    `Wroxham`,
    `Hingham`,
    `Harleston`,
    `Thornham`,
    `Ormesby St Margaret`
  ],
  Northamptonshire: [
    'Long Buckby',
    'Oundle',
    'Daventry',
    'Thrapston',
    'Silverstone',
    'Hardingstone',
    'Earls Barton',
    'Weedon',
    'Aynho',
    'The Bringtons'
  ],
  Nottinghamshire: [
    'Newark-on-Trent',
    'West Bridgford',
    'Beeston',
    'Farnsfield',
    'Mapperley',
    'The Park, Nottingham',
    'Woodborough',
    'Southwell',
    'Edwinstowe',
    'Wollaton'
  ],
  Oxfordshire: [
    'Woodstock',
    'Wallingford',
    'Watlington',
    'Henley-on-Thames',
    'Goring',
    'Charlbury',
    'East Oxford',
    'Burford',
    'Whitchurch-on-Thames',
    'Warborough'
  ],
  'Somerset & Bristol': [
    'Castle Cary',
    'Wells',
    'Langport',
    'South Petherton',
    'Frome',
    'Widcombe, Bath',
    'Bruton',
    'Chew Magna',
    'Southville, Bristol',
    'Hinton St George'
  ],
  Suffolk: [
    'Woodbridge',
    'Bury St Edmunds',
    'Southwold',
    'Lavenham',
    'Framlingham',
    'Long Melford',
    'Beccles',
    'East Bergholt',
    'Kersey',
    'Halesworth'
  ],
  Surrey: [
    'Farnham',
    'Reigate',
    'Oxted',
    'Weybridge',
    'Cobham',
    'Claygate',
    'Haslemere',
    'Englefield Green',
    'Guildford',
    'East Molesey'
  ],
  Sussex: [
    'Chichester',
    'Lewes',
    'East Grinstead',
    'Ticehurst',
    'Midhurst',
    'St Leonards-On-Sea',
    'Cuckfield',
    'Petworth',
    'Rye',
    'Hove'
  ],
  Warwickshire: [
    'Leamington Spa',
    'Warwick',
    'Shipston-on-Stour',
    'Alcester',
    'Henley-in-Arden',
    'Kenilworth',
    'Stratford-upon-Avon',
    'Wellesbourne',
    'Atherstone',
    'Dunchurch'
  ],
  'West Midlands': [
    'Hampton-in-Arden',
    'Bournville',
    'Earlsdon',
    'Harborne',
    'Kings Heath',
    'Four Oaks',
    'Meriden',
    'Dorridge',
    'Moseley',
    'Edgbaston'
  ],
  Wiltshire: [
    'Malmesbury',
    'Salisbury',
    'Corsham',
    'Bradford on Avon',
    'Marlborough',
    'Pewsey',
    'Lacock',
    'Mere',
    'Tisbury',
    'Box'
  ],
  Worcestershire: [
    'Broadway',
    'Malvern',
    'Bewdley',
    'Ombersley',
    'Pershore',
    'Upton-upon-Severn',
    'Inkberrow',
    'Barnt Green',
    'Evesham',
    'Tenbury Wells'
  ],
  'Best of the Rest': [
    'East Dulwich, London',
    'Crouch End, London',
    'Harrogate, Yorkshire',
    'Barton-Under-Needwood, Staffordshire',
    'Helmsley, North Yorkshire',
    'Ledbury, Herefordshire',
    'Stamford, Lincolnshire',
    'Shrewsbury, Shropshire'
  ]
}

export default BPTL_RESULTS
